import type { RouterConfig } from '@nuxt/schema'

const isScanRoute = (path: string) => /\/results\/scan(?:\/|$)/.test(path)
const isScanHistoryDetailRoute = (path: string) => /\/results\/scan\/history\/\d+(?:\/|$)/.test(path)

export default <RouterConfig>{
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition

		const normalize = (path: string) => path.replace(/\/+$/, '') || '/'
		const samePath = normalize(to.path) === normalize(from.path)
		if (samePath) return false

		const navigatingWithinScanModule = isScanRoute(to.path) && isScanRoute(from.path)
		if (!navigatingWithinScanModule) return { top: 0 }

		const targetSelector = isScanHistoryDetailRoute(to.path) ? '#ticket-detail' : '#scan-module'

		return new Promise((resolve) => {
			requestAnimationFrame(() => {
				resolve({
					el: targetSelector,
					top: 0,
					behavior: 'auto',
				})
			})
		})
	},
}
